import { Fingerprint, Code2, Megaphone, Share2, BarChart3, Server, CalendarRange, RadioTower } from "lucide-react";

export const SERVICES = [
  {
    key: "branding",
    icon: Fingerprint,
    title: "Branding",
    tag: "Strategy & identity",
    blurb: "You are your brand. We shape identities that stick — strategy, voice, logo and visual language built as one system.",
    blurbLong:
      "You are your brand. We dig into who you are, then build the name, voice, logo and visual language that make people remember you — and keep coming back.",
    features: ["Brand strategy & naming", "Visual identity & logo systems", "Brand guidelines & rollout", "Rebrands & refreshes"],
    imageKey: "branding",
  },
  {
    key: "software",
    icon: Code2,
    title: "Web & Software",
    tag: "Design & engineering",
    blurb: "From marketing sites to fully custom platforms — we design, build and run the software your project needs, online or locally.",
    blurbLong:
      "From your first landing page to fully custom platforms, we design, program and maintain the software your project needs — online or on-premise, always scalable.",
    features: ["Websites & e-commerce", "Custom platforms & apps", "APIs & integrations", "Hosting & maintenance"],
    imageKey: "hero",
  },
  {
    key: "advertising",
    icon: Megaphone,
    title: "Advertising & Media",
    tag: "Reach everywhere",
    blurb: "Internet, print, radio and TV — you build the package, we make sure it gets seen and heard.",
    blurbLong:
      "From internet advertising to print media, radio and TV — you build your package and we coordinate every channel so your project is impossible to miss.",
    features: ["Digital ad campaigns", "Print, radio & TV buying", "Creative production", "Package building"],
    imageKey: "broadcast",
  },
  {
    key: "social",
    icon: Share2,
    title: "Social Media",
    tag: "Community & growth",
    blurb: "Social decides how your business succeeds. Our professionals run — and monetize — your project online.",
    blurbLong:
      "Social media has a huge impact on how your business succeeds. Trust our professionals to run, grow and monetize your project online, end to end.",
    features: ["Content & community management", "Paid social campaigns", "Creator & influencer programs", "Monetization strategy"],
    imageKey: "team",
  },
  {
    key: "analytics",
    icon: BarChart3,
    title: "Analytics & Insights",
    tag: "Seeing more than numbers",
    blurb: "Comprehensive result analysis that helps you plan the future, not just read the past.",
    blurbLong:
      "Seeing more than just numbers. We turn every campaign into comprehensive result analysis, so you can plan the future with confidence instead of guessing.",
    features: ["Dashboards & reporting", "Conversion & attribution tracking", "Audience insights", "Data-driven planning"],
    imageKey: "office",
  },
  {
    key: "tech",
    icon: Server,
    title: "Technology & Infrastructure",
    tag: "Built to scale",
    blurb: "Servers collocated in major data centers across the globe, equipped with the latest technology.",
    blurbLong:
      "Our servers are collocated in the major data centers across the globe and equipped with the latest technology — so your project stays fast, safe and always on.",
    features: ["Global hosting & colocation", "Security & monitoring", "Scalable architecture", "24/7 uptime support"],
    imageKey: "hero",
  },
  {
    key: "events",
    icon: CalendarRange,
    title: "Events & Concerts",
    tag: "Stage, sound & lights",
    blurb: "Corporate or personal — we take your event to the next level. Stage, sound, lighting and artists: we got it all.",
    blurbLong:
      "Hosting a corporate or personal event? We assist in taking it to the next level. And when it comes to live concerts — stage, sound, lighting and artists — we got it all to make your show a success.",
    features: ["End-to-end event production", "Stage, sound & lighting", "Artist booking & management", "Corporate & private events"],
    imageKey: "concert",
  },
  {
    key: "radiotv",
    icon: RadioTower,
    title: "Radio & TV",
    tag: "Be seen. Be heard.",
    blurb: "We coordinate live radio shows and TV so your project is heard and seen — without the hassle.",
    blurbLong:
      "Advertise your business and events on live radio shows and take your ideas to live TV. We coordinate everything and make sure you will be heard and seen.",
    features: ["Live radio placements", "TV production & placement", "Show coordination", "On-air campaigns"],
    imageKey: "stage",
  },
];

export const MARQUEE_ITEMS = ["Branding", "Software", "Advertising", "Social Media", "Analytics", "Events", "Concerts", "Radio", "TV"];
